export default "__VITE_ASSET__CqZYnQ74__"